import {Component, OnInit} from '@angular/core';
import {AgreementService} from '../../resources/agreement/agreement.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(private agreement: AgreementService) {
  }


  ngAfterViewInit() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/dashboard.component.ts